export enum RoutingType {
  Supplier = 0,
  Plant = 1,
  ODC = 2,
  Checkpoint = 3,
  Dock = 4,
  Ferry = 5,
  Rail = 6,
  EDC = 7,
  CrossDock = 8,
  EPC = 9,
}

export function GetRoutingTypeDisplayName(
  routingType: RoutingType | undefined
) {
  if (routingType !== undefined) return RoutingType[routingType];
}
